module.exports = __webpack_public_path__ + "static/light-theme-4dfa0ef9975794e10f46a68e1753e82f.png";